module.exports = __webpack_public_path__ + "static/media/favicon1.dd29fa8d.jpeg";